<script>
import api from '@services/api'
import _sortBy from 'lodash/sortBy'

export default {
  name: 'WithJobInventoryItems',
  props: {
    jobId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      jobInventoryItems: [],
      areItemsLoading: false,
      error: null,
    }
  },
  watch: {
    jobId: {
      async handler(jobId) {
        if (jobId) {
          await this.loadJobInventoryItems(jobId)
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadJobInventoryItems(jobId) {
      this.areItemsLoading = true
      this.error = null

      try {
        const response = await api.getJobInventoryItems(jobId)
        this.jobInventoryItems = response.records || []
        this.jobInventoryItems = _sortBy(
          this.jobInventoryItems,
          'JOB_INVENTORY_ITEM_NAME'
        )
      } catch (error) {
        this.error = error
        console.error('Error loading job inventory items:', error)
      } finally {
        this.areItemsLoading = false
      }
    },
  },
  render() {
    const { jobInventoryItems, areItemsLoading, error } = this
    return this.$scopedSlots.default({
      jobInventoryItems,
      areItemsLoading,
      error,
    })
  },
}
</script>
